import { FaArrowLeft, FaChevronDown, FaEllipsisV } from 'react-icons/fa';

// Instagram is the "bad gmail" card — paired with John in the callout, so this
// card uses the male portrait. The female portrait moves to the TikTok card.
import johnPhoto from 'assets/avatars/tiktok.jpg';

import { SOCIAL_ICON_MD_PX, SOCIAL_ICON_SM_PX } from '../constants';
import * as styled from '../styles/social-bios';
import { AnimatedLinkBox } from './animated-link-box';

const CHEVRON_BADGE_PX = 9;

export const InstagramCard = ({
  initials,
  name,
  profession,
  slug,
  phase,
}: Landing.SocialBioCardContent & { phase: Landing.SocialBioPhase }) => (
  <styled.Card $isGood={phase === 'good'}>
    <styled.IgTopBar>
      <FaArrowLeft size={SOCIAL_ICON_MD_PX} />
      <styled.IgTopHandle>{slug}.studio</styled.IgTopHandle>
      <styled.IgTopRight>
        <FaEllipsisV size={SOCIAL_ICON_MD_PX} />
      </styled.IgTopRight>
    </styled.IgTopBar>
    <styled.IgIdentityRow>
      <styled.IgStoryRing>
        <styled.IgStoryRingInner>
          <styled.Avatar $size={4.6} $photoUrl={johnPhoto}>
            {initials}
          </styled.Avatar>
        </styled.IgStoryRingInner>
      </styled.IgStoryRing>
      <styled.IgStatRow>
        <styled.IgStatCol>
          <styled.IgStatNumber>80</styled.IgStatNumber>
          <styled.IgStatLabel>Posts</styled.IgStatLabel>
        </styled.IgStatCol>
        <styled.IgStatCol>
          <styled.IgStatNumber>12k</styled.IgStatNumber>
          <styled.IgStatLabel>Followers</styled.IgStatLabel>
        </styled.IgStatCol>
        <styled.IgStatCol>
          <styled.IgStatNumber>312</styled.IgStatNumber>
          <styled.IgStatLabel>Following</styled.IgStatLabel>
        </styled.IgStatCol>
      </styled.IgStatRow>
    </styled.IgIdentityRow>
    <styled.IgNameBlock>
      <styled.IgDisplayName>{name}</styled.IgDisplayName>
      <styled.IgCategory>{profession}</styled.IgCategory>
      <styled.IgBioBullet>• Bookings open weekly</styled.IgBioBullet>
      <styled.IgBioBullet>• DM only if you're serious 🙏</styled.IgBioBullet>
      <AnimatedLinkBox phase={phase} slug={slug} />
    </styled.IgNameBlock>
    <styled.IgFollowedBy>
      Followed by <strong>amber.b</strong> and 24 others
    </styled.IgFollowedBy>
    <styled.IgActionRow>
      <styled.IgButton $primary>
        Following <FaChevronDown size={CHEVRON_BADGE_PX} />
      </styled.IgButton>
      <styled.IgButton>Message</styled.IgButton>
      <styled.IgIconButton>
        <FaChevronDown size={SOCIAL_ICON_SM_PX} />
      </styled.IgIconButton>
    </styled.IgActionRow>
  </styled.Card>
);
